import React from 'react';

import { AttrsHelper } from '../../../sb-helpers/attrs-helper';
import { ColorUtil } from '../../../utils/color-util';

export type CardSectionBackgrounds =
  | 'light'
  | 'blue'
  | 'orange'
  | 'light orange'
  | 'light blue'
  | CssBackgroundImage;

export type CardSectionProps = {
  background?: CardSectionBackgrounds;
  children?: React.ReactNode;
  className?: string;
  divider?: boolean;
  name?: string;
};

export const CardSection = ({
  background = 'light',
  className,
  children,
  divider = false,
  name,
}: CardSectionProps) => {
  return (
    <div
      className={AttrsHelper.formatClassname(
        'card-section-container',
        typeof background === 'string' &&
          ColorUtil.nameClass({ color: background, prefix: 'background' }),
        divider && 'section-divider',
        className
      )}
      data-test={name}
      style={
        typeof background === 'object'
          ? {
              backgroundImage: background.image && `url("${background.image}")`,
              backgroundAttachment: background.attachment,
              backgroundClip: background.clip,
              backgroundColor: background.color,
              backgroundPosition: background.position || 'right center',
              backgroundRepeat: background.repeat || 'no-repeat',
              backgroundSize: background.size ?? 'contain',
            }
          : {}
      }
    >
      {children}
    </div>
  );
};
